
    import {Component, Vue } from 'vue-property-decorator';

    import { rulesApi} from "@/api/rules";
    import {IPage} from "@/js/page";
    import baseUrl, { imageUrl} from "../../constants";
    import guid from "@/common/guid";
    import format from "@/common/format";
    import { fileApi, mechanismApi} from "@/api/organization";
    import AddManufactory from "@/components/AddManufactory.vue";
    import ckeditor4 from "@/components/CkeditorComponent.vue";
    import SelectRules from "@/components/SelectRules.vue";
    import TempSave from "@/components/TempSave.vue";
    import SelectMechanism from "@/components/SelectMechanism.vue";
    @Component({
        name: "rulesDetail",
        components: {TempSave, AddManufactory, ckeditor4, SelectRules, SelectMechanism}
    })
    export default class Home extends Vue {
        loading = false;
        loadPage = false;  //整个页面的处理
        title = "公共标准详情";
        pageType = "0";  //0添加  1编辑  2查看 4 审核
        rulesType = "0";  //type 0 地方 1国家 2共享 3其它
        id = "0";
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        setDialog = false;  //单位组件
        unitAllList = [];
        queryString = "";
        addUnitDialog = {
          visible: false,
          rowIndex: -1,
          mode: ''
        };
        form = {
            id: 0,
            name: '',
            /**
             * 编号
             */
            number: '',

            /**
             * 发布机关
             */
            releaseOffice: '',
            releaseOfficeName: '',
            releaseOfficeNameId: "",
            /**
             * 发布文件编号
             */
            releaseFileNum: '',
            releaseFileNum1: '',
            releaseFileNum2: '',
            releaseFileNum3: '',

            /**
             * 发布日期
             */
            releaseTime: '',

            /**
             * 实施日期
             */
            implementTime: '',

            /**
             * 实施区域
             */
            implementRegion: '',

            /**
             * 状态0：未发布1：已发布
             */
            status: 0,

            /**
             * 代替规程规范
             */
            replaceRules: '',
            replaceRulesArr: [{id: "", number: "", name: ""}],

            /**
             * 被代替规程规范
             */
            beReplaceRules: '',
            beReplaceRulesArr: [] as any,

            /**
             * 起草人员
             */
            drafter: [{name: "",unit:"",label:""}] as any,

            /**
             * 影印件
             */
            enclosure: '',


            /**
             * 起草单位
             */
            draftUnit: [{name: "",label:""}] as any,
            /**
             * 现行状态
             */
            // currentStatus: '1',
            currentStatusText: '',
            /**
             * 0:地方 1:国家 2:其它
             */
            type: '0',

            /**
             * 起草单位
             */
            draftUnitPart: [{name: "",label:""}] as any,
            /**
             * 起草人员
             */
            drafterPart: [{name: "",unit:"",label:""}] as any,
            abolish: false,  //废止状态
            tableListOne: [{}],  //单条表格数据
            abolishNum: "",
            abolishDate: "",
        }
        review = {
            failText: '',
            failDialog: false,
        }
        rulesList = [] as any;
        validateNumber = (rule: any, value: any, cb: any) => {
            if(this.form.releaseFileNum1 == '' || this.form.releaseFileNum2== ''  || this.form.releaseFileNum3 == ''){
                return cb();
            }
            const number = this.form.releaseFileNum1+" "+ this.form.releaseFileNum2+"-"+ this.form.releaseFileNum3;
            if(this.form.number == number){
                return cb();
            }
            //必须这么取值，用this.rulesType取不到
            const rulesType = this.$route.params.rulesType;
            rulesApi.validateNumber({id: this.id, type: (rulesType=="3"?"2":rulesType), number: number}).then((r: any) => {
                if(r.data.result === 0){
                    cb();
                }else{
                    cb(new Error(r.data.message));
                }
            });
        }
        rules = {
            name: [{required: true, message: '请输入名称', trigger: 'blur'}],
            // number: [{required: true, message: '请输入编号', trigger: 'blur'}],
            releaseOfficeNameId: [{required: true, message: '请输入发布机关', trigger: 'blur'}],
            releaseFileNum: [{required: true, message: '请输入发布文件编号', trigger: 'blur'}],
            releaseFileNum1: [{validator: this.validateNumber,trigger:'blur'}, {required: true, message: '请选择', trigger: 'change'}],
            releaseFileNum2: [{validator: this.validateNumber,trigger:'blur'}, {required: true, message: '请输入标准号', trigger: 'blur'}],
            releaseFileNum3: [{validator: this.validateNumber,trigger:'blur'}, {required: true, message: '请输入年份', trigger: 'blur'}],
            releaseTime: [{required: true, message: '请选择发布日期', trigger: 'blur'}],
            implementTime: [{required: true, message: '请选择实施日期', trigger: 'blur'}],
            implementRegion: [{required: true, message: '请选择实施区域', trigger: 'change'}],
            replaceRules: [{required: true, message: '请选择代替规程规范', trigger: 'change'}],
            beReplaceRules: [{required: true, message: '请选择被代替规程规范', trigger: 'change'}],

            draftUnit: [{required: true, message: '请选择主要起草单位', trigger: 'change'}],
            drafterName: [{required: true, message: '请输入姓名', trigger: 'blur'}],
            drafterUnit: [{required: true, message: '请选择所在单位', trigger: 'change'}],
            drafter: [{required: true, message: '请设置主要起草人员', trigger: 'blur'}],

        }

        standardList = [];

        baseUrl = baseUrl
        headers = {Authorization: ""}
        imgGuid = guid()
        getMobileImgInterval = null as any;
        fileList = [] as any;
        mobileMsg = "";
        private closePage: any;
        dialogImageUrl = "";
        imagePreviewVisible = false;
        accept = ".pdf";
        limit = 1;
        listType = "picture-card"

        fullScreen = false;
        downloadRuleEnclosure = false;

        //生命周期销毁：
        destroyed() {
            // 清除定时器
            clearInterval(this.getMobileImgInterval);
        }

        created() {
            if(this.$route.path.indexOf("statistics/Details") != -1){
                this.fullScreen = true;
            }
            this.haveRight();
            this.init();

        }

      get completeUnit(): any[] {
        const arr = [
          ...this.cloneData(this.form.draftUnit),
          ...this.cloneData(this.form.draftUnitPart)
        ];
        arr.push(...this.form.drafter.filter((s: any) => s.label != '').map((e: any) => ({ name: e.unit, label: e.label })));
        arr.push(...this.form.drafterPart.filter((s: any) => s.label != '').map((e: any) => ({ name: e.unit, label: e.label })));
        return Array.from(
            arr
                .filter(item => item?.name)
                .reduce((map, cur) => {
                  if (!map.has(cur.name)) map.set(cur.name, cur);
                  return map;
                }, new Map())
                .values()
        );
      }
      cloneData(data: any){
          return JSON.parse(JSON.stringify(data))
      }

        init() {
            this.loading = true;
            this.loadPage = true;
            this.pageType = this.$route.params.type;
            this.id = this.$route.params.id;
            this.rulesType = this.$route.params.rulesType;
            this.headers.Authorization = this.$store.state.Authorization;
          if (this.id != "0") {
            this.getRules();
          }else {
            this.loading = false;
            this.loadPage = false;
          }
        }
        haveRight(){
            const right = this.$store.state.userRights;
            right.forEach((e:any)=>{
                if(e.name == "download_rule_enclosure"){
                    this.downloadRuleEnclosure = true;
                }
            });
        }
        changeReleaseFileNum(){
            if(this.form.releaseFileNum1 == '' || this.form.releaseFileNum2== ''  || this.form.releaseFileNum3 == ''){
                return
            }
            let form = this.$refs.form as HTMLFormElement;
            form.validateField('releaseFileNum1');
            form.validateField('releaseFileNum2');
            form.validateField('releaseFileNum3');
        }
        //上传监控
        handleAvatarSuccess(res: any, file: any) {
            if (res.result === 0) {
                const rData = res.data;
                // this.fileList.push({name: file.name,url: imageUrl+rData})
                this.fileList.push({name: "规程规范.pdf",url: imageUrl+rData})
                this.uploadConfig();
            }
        }

        //控制上传组件参数
        uploadConfig() {
            if (this.fileList.length == 0) {
                this.accept = ".pdf";
                this.limit = 1;
                this.listType = "picture-card"
            } else {
                const fix = this.filesuffix(this.fileList[0].url);
                if (fix == "jpg" || fix == "png") {
                    this.accept = '.png,.jpg';
                } else {
                    this.accept = '.pdf';
                    this.limit = 1;
                    this.listType = "text";
                }
            }
        }

        handleRemove(file: any, fileList: any) {
            const index = this.fileList.findIndex((e: any) => e.url === file.url);
            if (index > -1) {
                this.fileList.splice(index, 1);
            }
            this.uploadConfig();
            fileApi.deleteTemporaryFile({uuid: this.imgGuid})
        }

        handlePictureCardPreview(file: any) {
            const fix = this.filesuffix(file.url);
            if(fix == "pdf"){
                const path = file.url.replace(imageUrl,"");
                if(this.downloadRuleEnclosure){
                    window.open(baseUrl + "/file/download?file=" + path + "&name=" + file.name, '_blank');
                }else{
                    const router = this.$router.resolve({path: '/pdfviewer', query: {'pdfurl': encodeURI(path)}});
                    window.open(router.href,'_blank');
                }
            }else{
                this.dialogImageUrl = file.url;
                this.imagePreviewVisible = true;
            }
        }

        //上传监控
        beforeAvatarUpload(file: any) {
            const isPDF = file.type === 'application/pdf';

            if (!isPDF) {
                this.$message.error('上传图片只能是PDF格式!');
            }
            return (isPDF);
        }

        getMobileImg() {
            if (this.fileList.length == 0) {
                this.mobileMsg = "手机上传图片后，请等待本页面获取图片数据";
            }
            fileApi.getTemporaryFile({uuid: this.imgGuid}).then((r: any) => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    if (rData) {
                        this.mobileMsg = "获取文件成功！";
                        //判断图片格式和数量是否符合要求
                        const fix = this.filesuffix(rData);
                        if (this.fileList.length > 0 && fix == "pdf") {
                            this.mobileMsg = "获取文件成功！但是'pdf'文件只能上传一个！";
                            return
                        }
                        if (this.fileList.findIndex((e: any) => e.url === imageUrl + rData) == -1) {
                            this.fileList.push({name: "证书文件", url: imageUrl + rData})
                        }
                        this.uploadConfig();
                    }
                }
            })
        }

        filesuffix(fileName: string) {
            const first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
            const namelength = fileName.length;//取到文件名长度
            const filesuffix = fileName.substring(first + 1, namelength);//截取获得后缀名
            return filesuffix;
        }

        getRules() {
            rulesApi.getRules({id: this.id}).then((r: any) => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    rData.currentStatusText = rData.currentStatus.text;
                    if(rData.enclosure){
                        this.fileList = [];
                        try {
                            var obj=JSON.parse(rData.enclosure);
                            if(typeof obj == 'object' && obj ){
                                for(let i = 0; i < obj.length; i++){
                                    this.fileList.push({name: obj[i].name ,url: imageUrl+obj[i].url})
                                }
                                this.uploadConfig();
                            }
                        } catch(e) {
                            const arr = rData.enclosure.split(",");
                            for(let i = 0; i < arr.length; i++){
                                this.fileList.push({name:"证书文件",url: imageUrl+arr[i]})
                            }
                            this.uploadConfig();
                        }
                    }

                    if(rData.draftUnit){
                        rData.draftUnit = JSON.parse(rData.draftUnit);
                    }else{
                        rData.draftUnit = [{name: "",label:""}];
                    }
                    if(rData.draftUnitPart){
                        rData.draftUnitPart = JSON.parse(rData.draftUnitPart);
                    }else{
                        rData.draftUnitPart = [{name: "",label:""}];
                    }
                    if(rData.drafter){
                        rData.drafter = JSON.parse(rData.drafter);
                    }else{
                        rData.drafter = [{name: "",unit:"",label:""}];
                    }
                    if(rData.drafterPart){
                        rData.drafterPart = JSON.parse(rData.drafterPart);
                    }else{
                        rData.drafterPart = [{name: "",unit:"",label:""}];
                    }
                    if(rData.number){
                        const number = rData.number
                        const arr = this.parseCode(number);
                        if(arr.length == 3){
                            rData.releaseFileNum1 = arr[0];
                            rData.releaseFileNum2 = arr[1];
                            rData.releaseFileNum3 = arr[2];
                        }
                    }

                    rData.tableListOne = [{}];  //单条表格数据
                    if(rData.replaces.length > 0){
                        rData.replaceRulesArr = rData.replaces;
                    }else{
                        rData.replaceRulesArr = [{id: "", number: "", name: ""}];
                    }
                    if(rData.beReplace){
                        rData.beReplaceRulesArr = [{id: rData.beReplace.id, number: rData.beReplace.number, name: rData.beReplace.name, date: rData.beReplace.implementTime}]
                    }
                    this.form = Object.assign(this.form, rData);
                    this.$nextTick(()=>{
                        this.loading = false;
                        this.loadPage = false;
                    })
                }
            })
        }

        onSubmit(auditStatus: number, callback: any) {
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    let params = JSON.parse(JSON.stringify(this.form)) as any;
                    if(isNaN(params.releaseFileNum3) || params.releaseFileNum3.length != 4){
                        this.$message.error("【编号】的【年份】必须是4位数字");
                        return;
                    }
                    //2022-2-9只填废止文号，没有废止日期拦截
                    if(params.abolishNum && !params.abolishDate){
                        this.$message.error("填写了废止文号，必须填写废止日期");
                        return;
                    }
                    if(this.fileList.length == 0){
                        this.$message.error("影印件必传");
                        return;
                    }
                    // params.enclosure = this.fileList.flatMap((e: any) => e.url.replace(imageUrl, "")).join(",");
                    const enclosureList = this.fileList.map((e:any)=>{
                        return {
                            name: e.name,
                            url: e.url.replace(imageUrl,"")
                        }
                    })
                    params.enclosure = JSON.stringify(enclosureList);

                    if (this.id != "0") {
                        params = Object.assign(params, {id: this.id})
                    }

                    if(this.rulesType=="3"){
                        params.type = "2";
                    }else{
                        params.type = this.rulesType
                    }
                    params.releaseTime = format(params.releaseTime, 'YYYY-MM-DD HH:mm:ss');
                    params.implementTime = format(params.implementTime, 'YYYY-MM-DD HH:mm:ss');
                    params.abolishDate = format(params.abolishDate, 'YYYY-MM-DD HH:mm:ss');
                    params.draftUnit = JSON.stringify(params.draftUnit);
                    params.drafter = JSON.stringify(params.drafter);
                    params.draftUnitPart = JSON.stringify(params.draftUnitPart);
                    params.drafterPart = JSON.stringify(params.drafterPart);

                    const n1 = params.releaseFileNum1 ?? '';
                    const lastCh = n1.slice(-1);
                    const needSpace = n1 && lastCh !== ')' && lastCh !== '）';
                    params.number = n1 +
                        (needSpace ? ' ' : '') +
                        params.releaseFileNum2 +
                        '—' +
                        params.releaseFileNum3;

                    if(params.replaceRules != ""){
                        const obj = this.rulesList.find((e: any) => e.name == params.replaceRules) as any;
                        if(obj){
                            params.replaceRulesId = obj.id;
                        }else{
                            params.replaceRulesId = 0;
                        }
                    }else{
                        params.replaceRulesId = 0;
                    }
                    params.replaceRulesIds = params.replaceRulesArr.flatMap((e: any)=>e.id);
                    //判断代替规程不可重复
                    if(params.replaceRulesIds.indexOf(Number(this.id)) != -1){
                        this.$message.error("代替规程规范不能包括本身");
                        return;
                    }
                    //去重
                    params.replaceRulesIds = Array.from(new Set(params.replaceRulesIds));

                    // 2022-02-09是否废止按照废止日期后台判断
                    // params.abolish = params.abolishDate?1:0;
                    params.abolish = 0;

                    if(this.limit == 1){
                        //证明文件是pdf
                        params.pdfPath = params.enclosure;
                    }
                    params.auditStatus = auditStatus;
                    rulesApi.update(params).then((r: any) => {
                        if (r.data.result == 0) {
                            let $tempSave = this.$refs.tempSave as HTMLFormElement;
                            if ($tempSave) {
                                $tempSave.deleteUserConfig();
                            }
                            if(callback){
                                callback();
                                return;
                            }
                            this.$message.success("保存成功");
                            this.closePage();
                        }else{
                          this.$message.warning(r.data.message);
                          return;
                        }
                    })
                }
            })
        }

        deleteData(index: number, mode: string){
            if(mode === 'draftUnit'){
                this.form.draftUnit.splice(index, 1);
            }else if(mode === 'drafter'){
                this.form.drafter.splice(index, 1);
            }else if(mode === 'replaceRulesArr'){
                this.form.replaceRulesArr.splice(index, 1);
            }
            this.loading = true;
            this.$nextTick(()=>{
                this.loading = false;
            })
        }

        //代替规程编号查询后
        replaceRulesChange(e: any){
            if(e){
                const rData = this.form.replaceRulesArr[e.rowIndex];
                if(rData){
                    rData.id = e.id;
                    rData.number = e.number;
                    rData.name = e.name;
                }
            }
        }
        //实施日期改变
        replaceRulesTableBox = true;
        implementTimeChange(){
            this.replaceRulesTableBox = false;
            this.$nextTick(()=>{
                this.replaceRulesTableBox = true;
            })
        }

        deleteDataPart(index: number, mode: string){
            if(mode === 'draftUnitPart'){
                this.form.draftUnitPart.splice(index, 1);
            }else if(mode === 'drafterPart'){
                this.form.drafterPart.splice(index, 1);
            }else if(mode === 'draftUnit'){
              this.form.draftUnit.splice(index, 1);
            }else if(mode === 'drafter'){
              this.form.drafter.splice(index, 1);
            }else if(mode === 'replaceRulesArr'){
              this.form.replaceRulesArr.splice(index, 1);
            }
            this.loading = true;
            this.$nextTick(()=>{
                this.loading = false;
            });
        }

        addDataPart(type: number, mode: string){
            if(mode === 'draftUnitPart'){
                const draftUnitPart: any = this.form.draftUnitPart;
                const data = {name: "",unit:""};
              draftUnitPart.push(data);
            }else if(mode === 'drafterPart'){
                const drafter: any = this.form.drafterPart;
                const data = {name: "",unit:"", label: ""};
                drafter.push(data);
            }else if(mode === 'draftUnit'){
              const draftUnit: any = this.form.draftUnit;
              const data = {name: "",unit:""};
              draftUnit.push(data);
            }else if(mode === 'drafter'){
              const drafter: any = this.form.drafter;
              const data = {name: "",unit:"", label: ""};
              drafter.push(data);
            }else if(mode === 'replaceRulesArr'){
              const replaceRulesArr: any = this.form.replaceRulesArr;
              const data = {id: "", number: "", name: ""};
              replaceRulesArr.push(data);
            }
        }

        //改变发布机关
        changeManufactory(e: any) {
            this.form.releaseOfficeNameId = e.mechanismNameId;
            this.form.releaseOfficeName = e.mechanismName;
            this.form.releaseOffice = e.mechanismId;
        }

        changeDrafterUnit(e: any){
          const {rowIndex, mechanismNameId, mechanismName} = e;
          this.$set(this.form.draftUnit[rowIndex], 'label', mechanismName);
          this.$set(this.form.draftUnit[rowIndex], 'name', mechanismNameId);
        }

        changeDrafterPartUnit(e: any){
          const {rowIndex, mechanismNameId, mechanismName} = e;
          this.$set(this.form.draftUnitPart[rowIndex], 'label', mechanismName);
          this.$set(this.form.draftUnitPart[rowIndex], 'name', mechanismNameId);
        }

        changeUserUnit(row: any, rowIndex: number, mode: string){
          if(row.unit === '-1'){
            this.onAddUnitDialog(rowIndex, mode);
          }else{
            const units = this.completeUnit;
            let unit = units.find((s: any) => s.name === row.unit);
            if(unit){
              row.label = unit.label;
            }else{
              unit = this.unitAllList.find((u: any) => u.id === row.unit);
              if(unit){
                row.label = unit.name;
              }else{
                row.label = "";
              }
            }
          }

          this.queryString = '';
        }

        downBtn() {
            this.$message.error("下载，暂未实现");
        }

        passOrNot(status: number) {
            //通过或不通过
            if (status == 3) {
                //不通过，必须有原因
                if (this.review.failText == "") {
                    this.$message.error("请填写不通过原因");
                    return
                }
            }
            this.onSubmit(status, () => {
                rulesApi.examine(this.id, status, this.review.failText).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("审核成功，1秒后返回上一页！");
                        this.closeFail();
                        setTimeout(() => {
                            this.closePage()
                        }, 1000);
                    }
                })
            });
        }
        hasBtn(mode: string){
            if(mode === 'down'){
                return this.pageType == '2';
            }else if(mode === 'save'){
                return this.pageType == '0' || this.pageType == '1';
            }else if(mode === 'submit'){
                return this.pageType == '0' || this.pageType == '1';
            }else if(mode === 'audit'){
                return this.pageType == '4';
            }else if(mode === 'tempSave'){
                return this.pageType == '0';
            }else{
                return false;
            }
        }

        closeFail() {
            setTimeout(() => {
                this.review.failText = "";
            }, 500)
            this.review.failDialog = false;
        }
        getTempData(e: any) {
            if(e) {
                const rData = JSON.parse(e);
                this.form = rData.form;
                if (rData.fileList) {
                    this.fileList = rData.fileList;
                }
            }
        }
        clearForm() {
            const options = this.$options as any;
            Object.assign(this.$data, options.data.call(this));
            this.init();
        }

      querySearch(queryString: string, cb: any){
          let options = [{value: "全国"}, {value: "河北省"}, {value: "京津冀"}, {value: "华北大区"}, {value: "其他"}];
          if(queryString){
            options = options.filter(option => option.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
          cb(options);
      }
      parseCode(code: string) {
        // 1. 统一破折号，去掉首尾空白
        const s = code.replace(/[—–]/g, '').trim();

        // 2. 找“前缀”结束位置：最后一个空格 或 最后一个右括号（中英文都算）
        let breakPos = -1;
        const lastSp = s.lastIndexOf(' ');
        const lastEn = s.lastIndexOf(')');
        const lastZh = s.lastIndexOf('）');
        breakPos = Math.max(lastSp, lastEn, lastZh); // 取最靠后的那个

        // 3. 截取三段
        const prefix = breakPos === -1 ? '' : s.slice(0, breakPos + 1).trim();
        const numYear = breakPos === -1 ? s : s.slice(breakPos + 1);
        const m = numYear.match(/^(.+?)(\d{4})$/);
        if (!m) throw new Error('无法识别的编号格式：' + code);

        return [prefix, m[1], m[2]];
      }

      remoteMethod(query: string){
        if(query != ''){
          this.queryString = query;
          mechanismApi.list2({
            size: 100,
            current: 1,
            name: query
          }).then(r => {
            if(r.data.result === 0){
              this.unitAllList = r.data.data.records;
            }else{
              this.unitAllList = [];
            }
          });
        }else{
          this.unitAllList = [];
          this.queryString = '';
        }
      }
      onAddUnitDialog(rowIndex: number, mode: string){
        this.addUnitDialog.visible = true;
        this.addUnitDialog.mode = mode;
        this.addUnitDialog.rowIndex = rowIndex;
      }
      closeUnitDialog(){
        this.addUnitDialog.visible = false;
        this.addUnitDialog.mode = '';
        this.queryString = '';
        this.addUnitDialog.rowIndex = -1;
      }
      addSaveSuccess(e: any){
        if(e == null || e.splitName == undefined || e.splitName.length === 0){
          this.$message.error('数据异常！未找到该企业下的名称');
          return;
        }

        const { mode, rowIndex } = this.addUnitDialog;
        if('drafter' === mode){
          this.form.drafter[rowIndex].unit = e?e.id:'';
          this.form.drafter[rowIndex].label = e?e.name:'';
        }else if('drafterPart' === mode){
          this.form.drafterPart[rowIndex].unit = e?e.id:'';
          this.form.drafterPart[rowIndex].label = e?e.name:'';
        }
        this.closeUnitDialog();
      }
    }
